export default __webpack_public_path__ + "static/media/blog11.2895a96c.jpg";